export default function getInnerHeight(el) {
    const { offsetHeight } = el;
    const { paddingTop, paddingBottom } = getComputedStyle(el);
    return offsetHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}



// WEBPACK FOOTER //
// ./src/widget/ScrollBar/utils/getInnerHeight.js